import { FieldErrors, useForm, UseFormReturn } from 'react-hook-form'
import { HouseConsignmentFormValues } from 'features/declaration/house-consignment/models/schema'
import {
  blankBuyer,
  blankConsignee,
  blankConsignor,
  blankPlaceOfAcceptance,
  blankPlaceOfDelivery,
  blankSeller,
} from 'features/declaration/models/blankItems'
import { ErrorResult } from '../../../../shared/models/types'
import houseConsignmentFormResolver from './houseConsignmentFormResolver'
import { useDeclarationEditorContext, useServerRequirementsContext } from '../../form/contexts/DeclarationEditorContext'
import { HouseConsignmentFormValuesSaveResult } from './useSaveHouseConsignmentForm'

export type HouseConsignmentFormSaveResult =
  { success: true; data: HouseConsignmentFormValuesSaveResult }
  | { success: false; errorReason: 'validation' | 'general' | 'unexpected'; formErrors?: FieldErrors<HouseConsignmentFormValues>; errors?: ErrorResult[] }

export const initialFormData: HouseConsignmentFormValues = {
  id: null,
  sequenceNumber: 0,
  grossMass: 0,
  referenceNumberUCR: '',
  securityIndicatorFromExportDeclaration: '',
  transportChargesMethodOfPayment: '',
  consignor: blankConsignor,
  consignee: blankConsignee,
  buyer: blankBuyer,
  seller: blankSeller,
  countryOfDestination: '',
  countryOfDispatch: '',
  additionalSupplyChainActor: [],
  departureTransportMeans: [],
  previousDocument: [],
  supportingDocument: [],
  transportDocument: [],
  additionalReference: [],
  additionalInformation: [],
  consignmentItem: [],
  placeOfAcceptance: blankPlaceOfAcceptance,
  placeOfDelivery: blankPlaceOfDelivery,
  countriesOfRouting: [],
  transportEquipment: [],
  containerIndicator: 'false',
  passiveBorderTransportMeans: [],
  differentBuyer: false,
  differentSeller: false,
  differentCountriesOfRouting: false,
  differentPlaceOfAcceptance: false,
  differentPlaceOfDelivery: false,
}

function useHouseConsignmentForm() {
  const { validationContextRef } = useDeclarationEditorContext()
  const { serverValidationResult } = useServerRequirementsContext('houseConsignment')

  const resolverContext = {
    ...(validationContextRef.current ?? {}),
    serverValidationResult,
  }

  const form: UseHouseConsignmentFormReturn = useForm<HouseConsignmentFormValues>({
    mode: 'onBlur',
    defaultValues: initialFormData,
    resolver: houseConsignmentFormResolver,
    context: resolverContext,
  })

  return {
    form,
  }
}

export type UseHouseConsignmentFormReturn = UseFormReturn<HouseConsignmentFormValues>

export default useHouseConsignmentForm
